export default "__VITE_ASSET__D65pC1fh__"